import BeyondBurger, { BeyondBurgerProps } from "./BeyondBurger";

export { BeyondBurger, BeyondBurgerProps };

export default BeyondBurger;
